export default "__VITE_ASSET__67f2cf61__"